module.exports = __webpack_public_path__ + "static/media/check.045aa0de.svg";